import React from 'react';

interface Props {
  onClick?: () => void;
  /** Extra class e.g. calendar-day-row__add */
  className?: string;
  /** When true, renders as span (parent handles click) */
  decorative?: boolean;
  /** Minimal flat + for dense day headers */
  variant?: 'default' | 'minimal';
  'aria-label'?: string;
}

/** Secondary circular + with a slow rotating primary-color ring. */
export function CalendarDayAddButton({
  onClick,
  className = '',
  decorative = false,
  variant = 'default',
  'aria-label': ariaLabel,
}: Props) {
  const cls = [
    'cal-day-add-btn',
    variant === 'minimal' ? 'cal-day-add-btn--minimal' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const inner =
    variant === 'minimal' ? (
      <span className="cal-day-add-btn__plus" aria-hidden={decorative}>
        +
      </span>
    ) : (
      <>
        <span className="cal-day-add-btn__ring" aria-hidden />
        <span className="cal-day-add-btn__plus" aria-hidden={decorative}>
          +
        </span>
      </>
    );

  if (decorative) {
    return <span className={`${cls} cal-day-add-btn--decorative`}>{inner}</span>;
  }

  return (
    <button type="button" className={cls} onClick={onClick} aria-label={ariaLabel}>
      {inner}
    </button>
  );
}
